import LoaderSpin from 'snippets/loader-spin/loader-spin'
import Price from 'snippets/price/price'

function ButtonATC({
  text,
  hiddenMarkDash = false,
  onHandle,
  price,
  originalPrice,
  loading,
  disabled = false,
  type = 'button',
  buttonClass = 'button-primary button-large',
  hiddenPrice = false
}) {
  const classCustom = `relative w-full ${buttonClass} ${!disabled ? '' : 'text-neutral-400'}`

  return (
    <button
      type={type === 'button' ? 'button' : 'submit'}
      className={classCustom}
      disabled={disabled}
      onClick={() => onHandle()}
    >
      {loading ? (
        <LoaderSpin size={3} className="mx-auto" />
      ) : (
        <>
          {text} {!hiddenPrice && !hiddenMarkDash && '-'}{' '}
          {!hiddenPrice && (
            <Price className="inline text-xs" price={price} originalPrice={originalPrice} />
          )}
        </>
      )}
    </button>
  )
}

export default ButtonATC
